import { INACTIVITY_TIMER } from '@app/constants';
import { useEffect, useState } from 'react';

const useInactivityLogoutTimer = onInactive => {
  const [lastActivity, setLastActivity] = useState(Date.now());

  useEffect(() => {
    const handleActivity = () => {
      setLastActivity(Date.now());
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    const checkInactivity = setInterval(() => {
      if (Date.now() - lastActivity > INACTIVITY_TIMER.TRESHOLD) {
        onInactive();
      }
    }, INACTIVITY_TIMER.TIMEOUT);

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(checkInactivity);
    };
  }, [lastActivity]);

  return null;
};

export default useInactivityLogoutTimer;
